import { forwardRef, ForwardRefRenderFunction } from "react"
import { FormControl } from "styles/FormControl";
import { InputProps } from 'types/Input';

export const ForwardedInput: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (props, ref) => {
  return <FormControl as="input" ref={ref} {...props} />;
};

export default forwardRef(ForwardedInput);
